"use strict";
exports.__esModule = true;
var angular = require("angular");
var so_rich_text_box_component_1 = require("../../../../../../components/so-rich-text-box/so-rich-text-box.component");
angular.module('smartorg.r6.acts.inputScreen', [
    'rzModule',
    'ui.bootstrap',
    so_rich_text_box_component_1["default"],
    require('../../../comment-box/probability-form/probability-form.component'),
    require('../../../comment-box/range-form/range-form.component'),
]);
require('./smart-constraint-directive');
require('./input-screen-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.acts.inputScreen';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/input-screen/app/js/plumbing/app.js